export default __webpack_public_path__ + "static/media/profesi.7510039a.svg";